"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/TimeInput.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);























const hours = Array.from({ length: 12 }, (_, i) => i + 1)
const minutes = [0, 15, 30, 45]
const periods = ['AM', 'PM'] 



const getPeriod = (m) => m.hour() >= 12 ? 'PM' : 'AM'

const getDisplayHour = (m) => {
  const hour = m.hour() % 12
  return hour || 12
}

const getTime = (
  source,
  hour,
  minute,
  period,
) => {
  const hour24 = period === 'AM'
    ? hour % 12
    : (hour % 12) + 12

  return _moment2.default.call(void 0, source).hour(hour24).minute(minute).second(0).millisecond(0)
}

const TimeInput = ({
  isOpen,
  onOpen,
  onClose,
  defaultValue = _moment2.default.call(void 0, ).hour(0).minute(0).second(0).millisecond(0),
  value,
  onChange,
  disabled,
  className,
  isRequired,
  popupAlign = 'left',
  placeholder = 'None',
  ariaLabel,
  hasError,
  popupClassName,
  popupPlacement,
}) => {
  const rootRef = _react.useRef(null)
  const triggerRef = _react.useRef(null)
  const popupRef = _react.useRef(null)
  const selectedTime = value || defaultValue
  const selectedHour = getDisplayHour(selectedTime)
  const selectedMinute = selectedTime.minute()
  const selectedPeriod = getPeriod(selectedTime)

  // Rev 27 P4: opening puts focus on the hour, scrolled into view (the
  // default's while there's no value).
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const hour = _optionalChain([popupRef, 'access', _2 => _2.current, 'optionalAccess', _3 => _3.querySelector, 'call', _4 => _4('[data-hour-start]')])
      _optionalChain([hour, 'optionalAccess', _5 => _5.scrollIntoView, 'optionalCall', _6 => _6({ block: 'center' })])
      _optionalChain([hour, 'optionalAccess', _7 => _7.focus, 'call', _8 => _8({ preventScroll: true })])
    },
    // Only on opening; picking keeps focus where it is.
    [isOpen],
  )

  const displayValue = _react.useMemo.call(void 0, 
    () => value ? value.format('h:mm A') : placeholder,
    [value, placeholder],
  )

  const selectTime = (hour, minute, period) =>
    onChange(getTime(selectedTime, hour, minute, period))

  const togglePopup = () => {
    if (isOpen) onClose()
    else onOpen()
  }

  const closeToTrigger = () => {
    onClose()
    _optionalChain([triggerRef, 'access', _9 => _9.current, 'optionalAccess', _10 => _10.focus, 'call', _11 => _11()])
  }

  const clearValue = (e) => {
    e.stopPropagation()
    if (isRequired) return
    onChange(null)
  }

  // Arrows move within a column, Left/Right between them (to the column's
  // selected option), Home/End to its ends; Enter and Space pick (they're
  // buttons). Tab leaves and closes, as from a native select.
  const onPopupKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault()
      closeToTrigger()
      return
    }
    const current = e.target 
    const col = current.closest('[role="listbox"]')
    if (!col) return
    const options = (el) =>
      [..._nullishCoalesce(_optionalChain([el, 'optionalAccess', _12 => _12.querySelectorAll, 'call', _13 => _13('[role="option"]')]), () => ( []))]
    const inCol = options(col)
    const at = inCol.indexOf(current)
    const focus = (el) => {
      if (!el) return
      e.preventDefault()
      _optionalChain([el, 'access', _14 => _14.scrollIntoView, 'optionalCall', _15 => _15({ block: 'nearest' })])
      el.focus({ preventScroll: true })
    }
    const toColumn = (el) => {
      const next = options(el)
      focus(_nullishCoalesce(next.find(o => o.getAttribute('data-current') === 'true'), () => ( next[0])))
    }
    if (e.key === 'ArrowDown') focus(inCol[Math.min(at + 1, inCol.length - 1)])
    else if (e.key === 'ArrowUp') focus(inCol[Math.max(at - 1, 0)])
    else if (e.key === 'Home') focus(inCol[0])
    else if (e.key === 'End') focus(inCol[inCol.length - 1])
    else if (e.key === 'ArrowRight') toColumn(col.nextElementSibling)
    else if (e.key === 'ArrowLeft') toColumn(col.previousElementSibling)
  }

  const renderOption = (
    key,
    label,
    isCurrent,
    onPick,
    extra = {},
  ) => (
    _react2.default.createElement('button', {
      key: key,
      type: "button",
      role: "option",
      // A clear selected state only once there's a value (Rev 27 P4).
      'aria-selected': !!value && isCurrent,
      'data-current': isCurrent,
      tabIndex: -1,
      className: _classBuilder2.default.call(void 0, 
        'blm-time-input--option',
        value && isCurrent && 'blm-time-input--option--selected',
      ),
      onClick: onPick,
      ...extra, __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}

      ,  label 
    )
  )

  return (
    _react2.default.createElement('div', {
      ref: rootRef,
      className: _classBuilder2.default.call(void 0, 
        className,
        'blm-time-input',
        disabled && 'blm-time-input--disabled',
        hasError && 'blm-time-input--error',
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}

      , _react2.default.createElement('button', {
        ref: triggerRef,
        type: "button",
        className: "blm-time-input--trigger",
        onClick: togglePopup,
        onKeyDown: e => {
          if (e.key !== 'ArrowDown' || isOpen) return
          e.preventDefault()
          onOpen()
        },
        disabled: disabled,
        'aria-haspopup': "listbox",
        'aria-expanded': isOpen,
        'aria-label': ariaLabel && `${ariaLabel}, ${value ? displayValue : 'not set'}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}

        , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, !value && 'blm-time-input--placeholder'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}}
          ,  displayValue 
        )
      )
      ,  !isRequired && value && !disabled && (
        _react2.default.createElement('button', {
          type: "button",
          className: "blm-time-input--clear",
          onClick: clearValue,
          'aria-label': "Clear time" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}

          , _react2.default.createElement('img', {
            className: "blm-time-input--clear-icon",
            src: "/assets/icons/icon-cross-grey.svg",
            alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}
          )
        )
      )
      , _react2.default.createElement('img', {
        className: "blm-time-input--dropdown-icon",
        src: "/assets/icons/dropdown-down-black.svg",
        alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
      )
      /* Rev 27 P4: in a layer above the dialog, so it's never clipped. */
      ,  isOpen && !disabled && (
        _react2.default.createElement(_Popover2.default, {
          anchorRef: rootRef,
          align: popupAlign,
          placement: popupPlacement,
          onClose: reason => reason === 'escape' ? closeToTrigger() : onClose(),
          className: popupClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}

          , _react2.default.createElement('div', { ref: popupRef, className: "blm-time-input--popup", onKeyDown: onPopupKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}
            , _react2.default.createElement('div', { role: "listbox", className: "blm-time-input--popup-col", 'aria-label': "Hour", __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}
              ,  hours.map(hour => renderOption(
                hour, String(hour), hour === selectedHour,
                () => selectTime(hour, selectedMinute, selectedPeriod),
                hour === selectedHour ? { 'data-hour-start': '' } : {},
              ))
            )
            , _react2.default.createElement('div', { role: "listbox", className: "blm-time-input--popup-col", 'aria-label': "Minute", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}
              ,  minutes.map(minute => renderOption(
                minute, minute.toString().padStart(2, '0'), minute === selectedMinute,
                () => selectTime(selectedHour, minute, selectedPeriod),
              ))
            )
            , _react2.default.createElement('div', { role: "listbox", className: "blm-time-input--popup-col", 'aria-label': "Period", __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}
              ,  periods.map(period => renderOption(
                period, period, period === selectedPeriod,
                () => selectTime(selectedHour, selectedMinute, period),
              ))
            )
          )
        )
      )
    )
  )
}

exports. default = TimeInput
